import MATRIZ from './matrizCorrecaoICV';
import { converterPT } from './tabelaConversaoICV';

// Aceita respostas como ARRAY ["0"|"1"|"2", ...] ou OBJETO { "1":"A"/"B"/"C", ... }
// Regra: alternativa marcada = 1, não marcada = 0.
export default function calcularResultadosICV(respostas = []) {
  // converte índice 0/1/2 -> letra A/B/C
  const idxToLetter = (v) => {
    const s = String(v).trim();
    if (s === '0') return 'A';
    if (s === '1') return 'B';
    if (s === '2') return 'C';
    return ''; // nada marcado
  };

  // obtém letra escolhida para a questão q (1-based)
  const getAlt = (q) => {
    // array (ICVForm)
    if (Array.isArray(respostas)) return idxToLetter(respostas[q - 1] ?? '');
    // objeto (casos antigos)
    const v = respostas[q] ?? respostas[String(q)] ?? '';
    const s = String(v).trim().toUpperCase();
    return s === 'A' || s === 'B' || s === 'C' ? s : idxToLetter(v);
  };

  const fatoresBase = ['DGV','I','II','III','IV','V','VI','VII','VIII','IX'];
  const brutos = Object.fromEntries(fatoresBase.map(f => [f, 0]));

  // soma 1 quando a alternativa marcada bate com a matriz
  for (const fator of fatoresBase) {
    const pares = MATRIZ[fator] || [];
    for (const [q, alt] of pares) {
      if (getAlt(q) === alt) brutos[fator] += 1;
    }
  }

  // compostos R e A
  brutos.R = (brutos.I || 0) + (brutos.II || 0) + (brutos.III || 0) + (brutos.IV || 0);
  brutos.A = (brutos.V || 0) + (brutos.VI || 0) + (brutos.VII || 0) + (brutos.VIII || 0);

  // conversão PD->PT
  const pts = {};
  for (const k of Object.keys(brutos)) pts[k] = converterPT(k, brutos[k]);

  return { brutos, pts };
}
